(function () {
	// KeenSlider is exposed on window by the theme bundle (see theme/src/main.ts),
	// so this block reuses the theme's copy instead of bundling its own.
	const init = (block) => {
		const KeenSlider = window.KeenSlider;
		const slider = block.querySelector('.keen-slider');
		if (!KeenSlider || !slider) return;

		const arrows = (s) => {
			const prev = block.querySelector('.keen-prev');
			const next = block.querySelector('.keen-next');
			prev && prev.addEventListener('click', () => s.prev());
			next && next.addEventListener('click', () => s.next());
		};

		new KeenSlider(
			slider,
			{
				// Variable-width slides: each slide sizes to its image (fixed height,
				// aspect-ratio width), so mixed formats are neither cropped nor distorted.
				mode: 'snap',
				slides: { perView: 'auto', spacing: 20 },
			},
			[arrows],
		);
	};

	const start = () => {
		document.querySelectorAll('.wp-block-krfrm-image-lightbox').forEach((block) => {
			if (block.dataset.initialized === '1') return;
			block.dataset.initialized = '1';
			init(block);
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
})();
